import { FC } from 'react'
import { Combobox as ComboboxHeadlessUI } from '@headlessui/react'
import { ComboboxOptionGroup } from './types'

type HeaderOptionProps = {
  option: ComboboxOptionGroup
}

export const HeaderOption: FC<HeaderOptionProps> = ({ option, children }) => {
  return (
    <>
      <ComboboxHeadlessUI.Option
        disabled
        className="relative mb-1 mt-1
        cursor-default select-none rounded-md border-b
        border-gray-50 bg-gray-50 px-4
        py-2 uppercase text-gray-500
        dark:border-gray-600 dark:bg-gray-600 dark:text-gray-200"
        value="">
        <span className="block truncate text-xs font-bold text-gray-400 dark:text-gray-300">
          {option.name}
        </span>
      </ComboboxHeadlessUI.Option>
      {children}
    </>
  )
}
